export enum FileType {
  Document = 0,
  Image = 1,
  Link = 2,
}
